
















import { defineComponent } from "@vue/composition-api";
import { TagsGrid } from "@/components.tags/tags-grid";
import { ContextHeader } from "@/components.nav/context-header";
import { Container, Heading, AbsBox } from "@ui";
import { useTranslate } from "@lang";

export default defineComponent({
	components:{
		TagsGrid,
		ContextHeader,
		Container,
		Heading,
		AbsBox,
	},
	setup(){
		const { translate } = useTranslate();
		return {
			translate
		};
	}
});

